/**
 * Format the remaining SLA time for display.
 *
 * | Time Remaining               | Format                                                  |
 * | ---------------------------- | ------------------------------------------------------- |
 * | 1–59 min (or overdue 1–59)   | Exact minutes: `29 min`, `-15 min`                      |
 * | 0                            | `0 min`                                                 |
 * | ≥60 min (or overdue ≥60)     | Quarter-hour increments: `1 hr`, `1.25 hrs`, `-2 hrs`   |
 * | ≥12 hrs (or overdue ≥12 hrs) | Whole-hour increments: `12 hrs`, `-13 hrs`              |
 */
export function formatSlaTime(completionSlaAt: string): string {
  const now = new Date()
  const slaDate = new Date(completionSlaAt)
  const diffMs = slaDate.getTime() - now.getTime()
  const diffMinutes = diffMs / (1000 * 60)

  const isOverdue = diffMinutes < 0
  const absMins = Math.abs(diffMinutes)
  const sign = isOverdue ? '-' : ''

  if (absMins < 60) {
    const rounded = Math.round(absMins)
    return `${sign}${rounded} min`
  }

  const absHours = absMins / 60

  if (absHours >= 12) {
    const rounded = Math.round(absHours)
    return `${sign}${rounded} hrs`
  }

  // Quarter-hour increments for 1–12 hours
  const quarters = Math.round(absHours * 4) / 4
  const unit = quarters === 1 ? 'hr' : 'hrs'
  return `${sign}${quarters} ${unit}`
}
